"use client";

import { Phone, MessageSquare, Mail, StickyNote } from "lucide-react";

export type ComposerType = "call" | "sms" | "whatsapp" | "email" | "note" | null;

interface ActionBarProps {
  activeComposer: ComposerType;
  onSetComposer: (composer: ComposerType) => void;
}

const actions = [
  { key: "call" as const, label: "Call", icon: Phone, color: "text-green-600 hover:bg-green-50" },
  { key: "sms" as const, label: "SMS", icon: MessageSquare, color: "text-teal-600 hover:bg-teal-50" },
  { key: "whatsapp" as const, label: "WhatsApp", icon: MessageSquare, color: "text-green-600 hover:bg-green-50" },
  { key: "email" as const, label: "Email", icon: Mail, color: "text-indigo-600 hover:bg-indigo-50" },
  { key: "note" as const, label: "Note", icon: StickyNote, color: "text-yellow-600 hover:bg-yellow-50" },
];

export function ActionBar({ activeComposer, onSetComposer }: ActionBarProps) {
  return (
    <div className="flex items-center justify-around border-t border-gray-200 bg-white px-2 py-2">
      {actions.map(({ key, label, icon: Icon, color }) => (
        <button
          key={key}
          onClick={() => onSetComposer(activeComposer === key ? null : key)}
          className={`flex flex-col items-center gap-0.5 rounded-lg px-3 py-1.5 text-[10px] font-medium transition-colors ${
            activeComposer === key ? "bg-gray-100 text-gray-900" : color
          }`}
        >
          <Icon className="h-4 w-4" />
          {label}
        </button>
      ))}
    </div>
  );
}
